import FootballState from "../../../state/football-state";
import Rule from "../../../../common/rule";

export default class Pass extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.Pass;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { passedBy } = fragment;
        gameContext.setCurrentPlayerInPossession(passedBy);
    }
}
